import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import _ from 'lodash';

class ApostilasDatatables extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const centers = this.props.apostilas.centers;

        if (!centers)
            return;

        const course = this.props.apostilas.selectedCourse;

        if (!course)
            return;

        const events = this.props.events;
        const token = this.props.token;

        const editorFields = [
            {
                "label": "Quantidade",
                "name": "qtd",
                "message": "Escolha um valor de 1 a 100",
                "default": 10
            },
            {
                "label": "Núcleo",
                "name": "center.id",
                "type": "select",
                "options": _.map(centers, function (center) { return center.toJS(); }),
                "optionsPair": {
                    "label": "name",
                    "value": "id"
                }
            }
        ];

        const editorCreateVisibleColumns = ['qtd'];
        const editorCreateHiddenColumns = null;
        const editorEditVisibleColumns = null;
        const editorEditHiddenColumns = ['qtd'];

        const datatablesColumns = [
            {
                data: function (data, type) {
                    if (type !== "display")
                        return null;

                    return '' +
                        '<div class="checkbox courseware-checkbox">' +
                        '<label>' +
                        '<input type="checkbox" value="' + data.id + '" aria-label="Selecionar apostila" />' +
                        '</label>' +
                        '</div>';
                },
                orderable: false,
                searchable: false,
                width: 14
            },
            {
                title: "Serial",
                width: 30,
                data: function (row, type) {
                    let curso = row.course.serial.toString();
                    if (curso.length === 1) curso = "0" + curso;

                    let nucleo = row.center.serial.toString();
                    if (nucleo.length === 1) nucleo = "00" + nucleo;
                    if (nucleo.length === 2) nucleo = "0" + nucleo;

                    let apostila = row.serial.toString();
                    if (apostila.length === 1) apostila = "00000" + apostila;
                    if (apostila.length === 2) apostila = "0000" + apostila;
                    if (apostila.length === 3) apostila = "000" + apostila;
                    if (apostila.length === 4) apostila = "00" + apostila;
                    if (apostila.length === 5) apostila = "0" + apostila;

                    return curso + nucleo + apostila;
                }
            },
            // { data: "id", title: "Código", render: $.datatable.renders.text() },
            { data: "center.name", title: "Núcleo", render: $.datatable.renders.text(), width: 160 },
            {
                data: function (data, type) {
                    if (type === "display")
                        return data.subscription ? '<span class="glyphicon glyphicon-ok" aria-hidden="true" style="color: #26C281!important;"></span>' : null;

                    if (type === 'sort')
                        return data.subscription ? 1 : 0;

                    return null;
                },
                title: 'Vinculada',
                orderable: true,
                width: 60
            },
            { data: "prints", title: "Etiquetas Impressas", render: $.datatable.renders.text(), width: 60 },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/courses/' + course.id + '/coursewares/select',
            createUrl: '/api/courses/' + course.id + '/coursewares/insert',
            editUrl: '/api/courses/' + course.id + '/coursewares/update/_id_',
            removeUrl: '/api/courses/' + course.id + '/coursewares/delete/_id_',
        });

        const selector = '.coursewares-datatables .courseware-checkbox input[type=checkbox]';

        const buttons = [
            {
                text: 'Todos',
                titleAttr: 'Selecionar Todos',
                action: function (e, dt) {
                    $(selector).prop('checked', true);
                }
            },
            {
                text: 'Nenhum',
                titleAttr: 'Desmarcar Todos',
                action: function (e, dt) {
                    $(selector).prop('checked', false);
                }
            },
            {
                text: 'Imprimir',
                titleAttr: 'Imprimir',
                action: function (e, dt) {
                    let coursewareIds = [];

                    $(selector).each(function () {
                        if ($(this).is(':checked')) {
                            coursewareIds.push($(this).val());
                        }
                    });

                    if (coursewareIds.length === 0) {
                        return events.onError(new Error('Nenhuma apostila foi selecionada para imprimir etiqueta'));
                    }

                    events.onPrintTicket(course, coursewareIds, token, success, events.onError);

                    function success(result) {
                        dt.ajax.reload();

                        // TODO: chama janela de sucesso
                        let filename = result.filename;

                        events.onShowDialog(
                            'Apostilas impressas com sucesso',
                            '<p><a href="' + filename + '" target="_blank">Clique aqui</a> para baixar arquivo de impressão.</p><br />'
                        );
                    }
                }
            },
        ];

        const order = [[4, "asc"], [1, "asc"]];
        const pageLength = 100;

        const editorCreateTitle = 'Inserir apostila';
        const editorEditTitle = 'Editar apostila';
        const editorRemoveTitle = 'Remover apostila';
        const editorRemoveMessage = 'Deseja remover esta apostila?';

        const domClassName = 'coursewares-datatables';
        const title = 'Apostilas de ' + course.name;
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       order={order}
                       pageLength={pageLength}
                       buttons={buttons}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorCreateVisibleColumns={editorCreateVisibleColumns}
                       editorCreateHiddenColumns={editorCreateHiddenColumns}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorEditVisibleColumns={editorEditVisibleColumns}
                       editorEditHiddenColumns={editorEditHiddenColumns}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

class Apostilas extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;
        const app = props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.APOSTILAS)
            return null;

        const apostilasStore = props.apostilas;

        const handleChange = function (e) {
            e.preventDefault();
            props.events.onSelectCourseForCoursewares(e.target.value);
        };

        let datatables = apostilasStore.selectedCourse ? <ApostilasDatatables {...this.props} /> : null;

        return (
            <div>
                <h1 className="page-header">Selecionar Curso</h1>

                <select value={apostilasStore.selectedCourse ? apostilasStore.selectedCourse.id : ""}
                        onChange={handleChange}
                        className="form-control">
                    <option key="null" value="">Nenhum</option>
                    {apostilasStore.courses.map(function (course) {
                        return <option key={course.id} value={course.id}>{course.name}</option>
                    })}
                </select>

                <br />

                {datatables}
            </div>
        );
    }
}

export default Apostilas;


// WEBPACK FOOTER //
// src/views/pages/Apostilas.jsx